/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json';
import ru from './locales/ru.json';

Vue.use(VueI18n);

const messages = {
  en, ru
};

// consider using an ICU message syntax
// with custom formatter, as described here: https://kazupon.github.io/vue-i18n/guide/formatting.html#custom-formatting)
// see an example here: https://github.com/kazupon/vue-i18n/blob/dev/examples/formatting/custom/src/formatter.js
const i18n = new VueI18n({
  locale: 'en',
  messages
});

export default i18n;
